import { jsx } from "react/jsx-runtime";
import { memo, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import TradeInInstock from "@perxis-auto/trade-in-instock";
import { actions } from "../../../../features/tradeIn/model/slice.js";
import { APP } from "../../../../shared/config/app.js";
import "../../../../shared/config/env.js";
import "../../../../shared/config/events.js";
import "@perxis-auto/ui-kit/lib/components/Grid";
import "@perxis-auto/ui-kit/lib/components/Typography";
import "../../../../shared/lib/store/createAppApi.js";
import "../../../../shared/lib/store/createAppAsyncThunk.js";
import "../../../../shared/lib/store/createAppSelector.js";
import "../../../../shared/lib/store/createAppSlice.js";
import "redux";
import "../../../../shared/lib/store/hooks/useAppDispatch.js";
import "../../../../shared/lib/store/hooks/useAppSelector.js";
import "../../../../shared/lib/store/hooks/useAppStore.js";
import "../../../../shared/store/config/middleware/index.js";
import "../../../../shared/store/config/model/selectors/selectBenefits.js";
import "../../../../shared/store/config/model/selectors/selectBooking.js";
import "../../../../shared/store/config/model/selectors/selectCredit.js";
import "../../../../shared/store/config/model/selectors/selectFilterGrid.js";
import "../../../../shared/store/config/model/selectors/selectFilterGridItems.js";
import "../../../../shared/store/config/model/selectors/selectFilters.js";
import "../../../../shared/store/config/model/selectors/selectGeolocator.js";
import "../../../../shared/store/config/model/selectors/selectLocationCollectionIds.js";
import "../../../../shared/store/config/model/selectors/selectMaps.js";
import "../../../../shared/store/config/model/selectors/selectModels.js";
import "../../../../shared/store/config/model/selectors/selectSort.js";
import "../../../../shared/store/config/model/selectors/selectTags.js";
import "../../../../shared/store/config/model/selectors/selectTradeIn.js";
import "../../../../shared/store/config/model/slice.js";
import "@perxis-auto/ui-kit/lib/components/Loader";
import "../../../../shared/context/constructor.js";
import "../../../../shared/context/this.js";
import "@perxis-auto/shared/lib";
import "@perxis-auto/shared";
import "../../../../shared/lib/constructor/mergeConstructor.js";
import "@perxis-auto/ui-kit";
import "../../../../shared/ui/constructorItem/ConstructorItem.js";
import { FinanceDrawer } from "../../../../shared/ui/financeDrawer/FinanceDrawer.js";
import "react-router";
import "@perxis-auto/shared/lib/lib/is/isObject";
import "@perxis-auto/ui-kit/lib/components/Button";
import "@perxis-auto/ui-kit/lib/components/Icon";
import "@perxis-auto/trade-in-instock/lib/trade-in-instock.css";
import styles from "./TradeInDrawer.module.scss.js";
const TradeInDrawer = memo(function TradeInDrawer2({ onClose }) {
  const { t } = useTranslation(APP.name);
  const dispatch = useDispatch();
  const onReset = useCallback(() => {
    dispatch(actions.reset());
  }, [dispatch]);
  const onSuccess = useCallback(
    (result) => {
      dispatch(actions.set(result));
      return onClose();
    },
    [dispatch, onClose]
  );
  return /* @__PURE__ */ jsx(FinanceDrawer, { title: t("widgets.finance.tradeInDrawer.title"), onClose, className: styles.tradeInDrawer, children: /* @__PURE__ */ jsx(TradeInInstock, { onReset, onSuccess }) });
});
export {
  TradeInDrawer
};
